/* eslint-disable react-hooks/exhaustive-deps */

// import NavRoutes from "./NavRoutes";
// import Main from "./components/pages/main/Main";
import Brochures from "./components/pages/brochures/Brochures";

const AppContainer = () => {
  return (
    <div>
      <div className="p-2">
        {/* <NavRoutes/> */}
        {/* <Main /> */}
        <Brochures/>
      </div>
    </div>
  );
};

export default AppContainer;
